import { Component , Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Generated class for the BeerHiveButtonComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'beer-hive-button',
  templateUrl: 'beer-hive-button.html',
  styleUrls: ['./beer-hive-button.scss'],
  standalone: false,
  // imports: [
  //   CommonModule,
  //   IonicModule,
  //   FormsModule,
  //   TranslateModule
  // ]
})
export class BeerHiveButtonComponent {

  @Input() name : String;

  constructor() {
  }

}
